export const ShipmentFeesEndpoint = (makeRequest) => {
    return {
        fetchAvailable(params, options) {
            return makeRequest('POST', '/v3/scheduling/shipment_fees/fetch_available', params, options);
        },
    };
};
//# sourceMappingURL=shipment_fees_endpoint.js.map